<template>
  <div class="profile-container">
    <div class="avatar-container">
      <Avatar :username="user.username" :online="false" :size="55" />
      <div :class="`status ${isOnline ? 'online' : 'offline'}`"></div>
    </div>
    <div class="content">
      <router-link class="username" :to="`/user/${user.username}`">{{ user.username }}</router-link>
      <span class="rank">{{ user.rank }}</span>
      <!-- <div class="exp-bar">
        <div class="juice" :style="{width: `${user.exp/user.maxExp*100}%`}"></div>
        <p class="label">{{user.exp}}/{{user.maxExp}}</p>
      </div>-->
      <div class="assets">
        <div class="credits-container">
          <img
            src="../../assets/credits.png"
            width="18"
            alt
            style="margin-bottom: -4px; margin-left: -2px"
          />
          {{ user.credits }} credits
        </div>
        <div class="cards-container">
          <img src="../../assets/back.png" class="card-back" alt />
          <span>x{{ totalCards.length }}</span> cards
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Avatar from "@/components/Avatar.vue";
export default {
  components: { Avatar },
  props: {
    user: Object,
    isOnline: Boolean
  },
  computed: {
    totalCards() {
      const { user } = this;
      let playerDiscoveredCards = [...user.cardIDs];
      Object.values(user.configuredDecks).forEach(deck => {
        playerDiscoveredCards = [...playerDiscoveredCards, ...deck.cardIDs];
      });
      return playerDiscoveredCards;
    }
  }
};
</script>
<style scoped>
.profile-container {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 10px;
  margin-left: -5px;
  width: 100%;
  display: flex;
  max-height: 90px;
}
@media screen and (max-width: 753px) {
  .profile-container {
    transform: translateX(0);
    margin-left: 0;
    position: static;
    max-height: auto;
    margin-bottom: 1em;
  }
}
.avatar-container {
  flex: 0 0 auto;
  align-self: center;
  position: relative;
  height: 55px;
  width: 55px;
}
.avatar {
  border-radius: 8px;
  position: absolute;
  height: 55px;
  width: 55px;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgb(102, 102, 102) none repeat scroll 0% 0%;
}
.avatar-container .status {
  position: absolute;
  bottom: -6px;
  right: -6px;
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 0.5rem;
}
.avatar-container .status.online {
  background: #55dc0d;
}
.avatar-container .status.offline {
  background: #dc2c0d;
}
.content {
  align-self: stretch;
  color: #111;
  margin-left: 10px;
  min-width: 25%;
}
.rank {
  line-height: 1.2;
  text-transform: uppercase;
  font-size: 9px;
  letter-spacing: 1px;
  display: block;
  color: #555;
}
.exp-bar {
  margin-top: 5px;
  border-radius: 4px;
  padding: 5px 16px;
  width: 100%;
  background: #c1cdc9;
  border: none;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
  border: 1px solid #bda753;
  height: 1rem;
  overflow: hidden;
  position: relative;
}
.exp-bar .juice {
  background: linear-gradient(#dbc25e, #a89548);
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  transition: 0.5s all ease-in-out;
}
.exp-bar .label {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  color: white;
  font-size: 0.5rem;
  margin: auto;
  text-align: center;
}
.cards-container span {
  margin-left: 3px;
}
.card-back {
  margin-bottom: -2px;
  border: 1px solid black;
  border-radius: 3px;
  height: 1.1em;
}
</style>
